import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { authenticationService } from "../../services/AuthenticationService";
import { onLogout } from "../../../redux/session/actions";
import MainContent from "../../components/main-content/MainContent";
import { mstrPath } from "../../../utils/mstrBase";
function LogoutPage(props) {
  const { onLogout, config, token, messageBundles } = props;
  const history = useHistory();

  useEffect(() => {
    async function logout() {
      if (config && token) {
        await authenticationService.logout(config, token);
        onLogout();
      }
    }
    logout();
  }, []);

  return (
    <MainContent
      sx={{
        background:
          "linear-gradient(137deg, rgba(17, 81, 143, 1) 15%, rgba(25,118,210,1) 22%, rgba(16,152,226,1) 31%)",
      }}
    >
      <Box
        sx={{
          width: "50%",
          marginLeft: "25%",
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center",
          height: "100%",
          backgroundColor: "white",
          justifyContent: "center",
        }}
      >
        <Typography
          gutterBottom
          sx={{
            fontSize: 18,
            fontWeight: "bold",
            color: "rgba(17, 81, 143, 1)",
            maxWidth: "50%",
            marginTop: "5%",
            marginBottom: "40px",
          }}
        >
          {messageBundles?.GENERIC_09
            ? messageBundles?.GENERIC_09
            : "Se ha cerrado su sesiÃƒÆ’Ã‚Â³n en la aplicaciÃƒÆ’Ã‚Â³n."}{" "}
        </Typography>
        <Typography
          gutterBottom
          sx={{
            textAlign: "center",
            fontSize: 14,
            color: "rgba(17, 81, 143, 1)",
            maxWidth: "90%",
            marginBottom: "20px",
            marginBottom: "2%",
          }}
        >
          {messageBundles?.GENERIC_10
            ? messageBundles?.GENERIC_10
            : "Si este evento ha sucedido debido a una perdida de sesiÃƒÆ’Ã‚Â³n o a la inactividad del usuario, haga click en el botÃƒÆ’Ã‚Â³n inferior para volver a introducir sus credenciales."}
        </Typography>
        <Button
          sx={{ width: "75%", height: "5%", fontSize: "16px" }}
          variant="contained"
          onClick={(x) => {
            history.push(mstrPath());
          }}
        >
          {" "}
          {messageBundles?.GENERIC_11 ? messageBundles?.GENERIC_11 : "Volver al Portal"}
        </Button>
      </Box>
    </MainContent>
  );
}
const mapStateToProps = (state) => {
  return {
    token: state.userDetails?.token,
    config: state.configuration,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      onLogout: onLogout,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoutPage);
